import { z } from 'zod';

export const agreementStatusSchema = z.enum(['new', 'active', 'canceled', 'terminated', 'expired']);

export type AgreementStatus = z.infer<typeof agreementStatusSchema>;
